import { PropagateLoader } from "react-spinners";

export default function SEDLoading() {
  return (
    <div
      id="CreatContact"
      className={"overlay-note middle-hand w100"}
      style={{ width: "100%", zIndex: "928832474677" }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginTop: "20%",
        }}
      >
        <PropagateLoader color="#f26524" />
      </div>
    </div>
  );
}
